export default __webpack_public_path__ + "static/media/screen_livechat_00.9f0f7f83.png";